import React, { useEffect, useState } from 'react';
import twitter from './assets/projet.png';
import mycine from './assets/mycine.png';
import snap from './assets/snap.jpg';
import france from './assets/france.png';
import us from './assets/us.png';
import meetic from './assets/meetic.jpg';
import irc from './assets/irc.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faCodepen, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import css from './App.css'
import fr from './trad/fr';
import en from './trad/en'; 


function App() {
 


  useEffect(() => {
    document.title = 'Tony Brechard - Portfolio';
  }, []);



   const [languageWeb, setlanguageWeb] = useState(france);


  const [charIndex, setCharIndex] = useState(3);
  const [displayText, setDisplayText] = useState('');
  const [htmlFlag, setHtmlFlag] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [messageemail, setMessageEmail] = useState('');
  const [status, setStatus] = useState('');

  const [language, setLanguage] = useState(fr); // Langue par défaut: français
  const [message, setMessage] = useState(language.hero.description);
  
  const [type_projet, setTypeProjet] = useState(0);
  const projects = language.projects?.web || [];
  const projet_mobile = language.projects?.mobile || [];

  useEffect(() => {
    document.title = 'Tony Brechard - Portfolio';
  }, []);

  const handleLanguageChange = (lang) => {
    if (lang === 'fr') {
      setLanguage(fr);
      setMessage(fr.hero.description);
      setlanguageWeb(france)
    } else {
      setLanguage(en);
      setMessage(en.hero.description);
      setlanguageWeb(us)
    }

    setCharIndex(3); // Réinitialiser l'index des caractères pour recommencer l'animation
    setDisplayText(''); // Réinitialiser le texte affiché

    setHtmlFlag(false)
  };
  


  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:tony.brechard@epitech.eu?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Nom: ${name}\nEmail: ${email}\n\nMessage:\n${messageemail}`)}`;
    window.location.href = mailtoLink;
    setStatus('Redirection vers votre client de messagerie...');
  };


  const ReloadMessage = () => {
    if (charIndex <= message.length) {
      const interval = setTimeout(() => {
        let currentChar = message.charAt(charIndex);

        if (currentChar === '<') {
          setHtmlFlag(true);
        }
        if (currentChar === '>') {
          setHtmlFlag(false);
        }

        setDisplayText(message.substring(0, charIndex));

        if (!htmlFlag) {
          setCharIndex(charIndex + 1);
        }
      }, 50);

      return () => clearTimeout(interval);
    }
  }
 
  useEffect(() => {
    ReloadMessage()
  }, [charIndex, htmlFlag, message]);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.project-card');
      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          element.classList.add('show');
        } else {
          element.classList.remove('show');
        }
      });
    };

    

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  



  const ChangeTypeProjet = (type) => {
    setTypeProjet(type);
  };

  useEffect(() => {
    const projectCards = document.querySelectorAll('.project-card');
    projectCards.forEach((card, index) => {
      card.classList.remove('show');
      setTimeout(() => {
        card.classList.add('show');
      }, index * 100); // Ajout d'un délai pour un effet d'apparition en cascade
    });
  }, [type_projet]);

  return (
    <div>
      {/* Header Section */}
      <div className="header-section" id='home'>
        <div className="header-navbar">
          <h1 className="logo">TB</h1>
          <ul>
            <a className='noa' href='#home'><li className="menu-item"><span className="number">01.</span> {language.navbar.home}</li></a>
            <a className='noa' href='#educ'><li className="menu-item"><span className="number">02.</span> {language.navbar.experience}</li></a>
            <a className='noa' href='#projet'><li className="menu-item"><span className="number">03.</span> {language.navbar.projects}</li></a>
            <a className='noa' href='#contact'><li className="menu-item"><span className="number">04.</span> {language.navbar.contact}</li></a>
            <li className="menu-item dropdown">
           <img className='logo-pays' src={languageWeb} alt="Français" />
              <ul className='drop'>
                <div className='colorb'>
                  <li><img className='logo-pays' src={france} onClick={() => handleLanguageChange('fr')} alt="Français" /></li>
                  <li><img className='logo-pays' src={us} onClick={() => handleLanguageChange('en')} alt="English" /></li>
                </div>
              </ul>
            </li>
          </ul>
        </div>

        <div className="hero-section">
          <div className='hero-content'>
            <h1 className='hi'>{language.hero.hello}</h1>
            <h1 className='name'>{language.hero.name}</h1>
            {/* <div className='pa'>{language.hero.description}</div>
             */}
              <div className='pa' id="textJava" dangerouslySetInnerHTML={{ __html: displayText }} />
            <div className='mejoindre'>
              <a href='https://github.com/onlyguts' target='_blank' rel='noopener noreferrer' title='GitHub'>
                <FontAwesomeIcon icon={faGithub} size="2x" />
              </a>
              <a href='https://codepen.io/TonyShner/' target='_blank' rel='noopener noreferrer' title='CodePen'>
                <FontAwesomeIcon icon={faCodepen} size="2x" />
              </a>
              <a href='https://fr.linkedin.com/in/tony-brechard-675b2b2a1' target='_blank' rel='noopener noreferrer' title='LinkedIn'>
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
           <a href='#projet'><button className='btn'>{language.hero.seeProjects}</button></a> 
          </div>
        </div>
      </div>

      {/* Education Section */}
      <div className="education-section" id='educ'>
        <h1 className='title'><span className='number'>02.</span> {language.education.title}</h1>
        <div className="education-container">
          <div className="education-item show">
            <h3 className='date'>{language.education.date}</h3>
            <div className='education-details'>
              <h3>{language.education.school}</h3>
              <p>{language.education.description}</p>
              <div className="tag">
                {language.education.tags.map((tag, index) => (
                  <div key={index}>{tag}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Projects Section */}
      <div className="projects-section" id='projet'>
      <h1 className='title2'><span className='number'>03.</span> {language.projects?.title || "Projets"}</h1>
      <div className='btnmain'>
        <button className='btn-projet' onClick={() => ChangeTypeProjet(0)}>{language.projects?.webButton || "Web"}</button>
        <button className='btn-projet' onClick={() => ChangeTypeProjet(1)}>{language.projects?.mobileButton || "Mobile"}</button>
      </div>
      {type_projet === 0 && (
        <div className="projects-container">
          {projects.map((project, index) => (
            <div className={`project-card ${type_projet === 0 ? 'show' : ''}`} key={index}>
              <img src={project.image} alt={project.title} />
              <div className="project-details">
                <a className='noa' href={project.link} target='_blank' rel='noopener noreferrer'>
                  <h3>{project.title} <FontAwesomeIcon icon={faExternalLinkAlt} className="link-icon" size="1x" /></h3>
                </a>
                <p>{project.description}</p>
                <div className="tag">
                  {project.tags.map((tag, i) => (
                    <div key={i}>{tag}</div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {type_projet === 1 && (
        <div className="projects-container">
          {projet_mobile.map((project, index) => (
            <div className={`project-card ${type_projet === 1 ? 'show' : ''}`} key={index}>
              <img src={project.image} alt={project.title} />
              <div className="project-details">
                <a className='noa' href={project.link} target='_blank' rel='noopener noreferrer'>
                  <h3>{project.title} <FontAwesomeIcon icon={faExternalLinkAlt} className="link-icon" size="1x" /></h3>
                </a>
                <p>{project.description}</p>
                <div className="tag">
                  {project.tags.map((tag, i) => (
                    <div key={i}>{tag}</div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

      {/* Contact Section */}
      <div className="contact-section" id='contact'>
        <h1 className="title"><span className="number">04.</span> {language.contact.title}</h1>
        <div className="contact-container">
          <div className="contact-details">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">{language.contact.form.name}:</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
         
              <div className="form-group">
                <label htmlFor="subject">{language.contact.form.subject}:</label>
                <input
                  type="text"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">{language.contact.form.message}:</label>
                <textarea
                  id="message"
                  value={messageemail}
                  onChange={(e) => setMessageEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-contact">{language.contact.form.send}</button>
            </form>
            {status && <p className="status-message">{status}</p>}
          </div>
        </div>
      </div>
      <div className='footer'>
        <div>{language.footer}</div>
      </div>
    </div>
  );
}

export default App;
